<template>
  <div class="bottom-bar w-100" v-if="activeStage.layout.sidebar_bot === true" v-bind:class="{ 'disabled': isActive === false}">


    <div class="h-100 d-flex align-items-center">
    <div class="bottom-bar-item-none" v-if="resultPage.isMediumRes === false">
      <div class="d-flex align-items-center gap-20">
        <span class="main-number" v-if="resultPage.isMediumRes === false" v-bind:class="{ 'disabled': isActive === false, 'done': isDone === true}">6</span>
        <span class="font-size-125" >{{ "Choose a result" | trans }}</span>
      </div>
    </div>

    <div class="h-100 d-flex">
      <div class="bottom-bar-item-none py-4">
      <div class="sys-container" v-if="this.activeStage.mainJob !== null">
        <div class="d-flex h-100 align-items-center px-3 font-size-125"></div>
        <div class="sys-thumb" @click="chooseActiveStage()" v-bind:class="{ 'active': image === this.activeStage.mainJob.apiJob.output[0].uri && activeStage.preview === true}">

          <img :src="this.activeStage.mainJob.apiJob.output[0].uri" class="sys-img">

        </div>
      </div>
      </div>

      <div class="bottom-bar-item-none h-100 px-3 py-2">
        <div class="d-flex h-100 align-items-center px-3 font-size-125"></div>

        <div v-for="sysJob in currentJob.getActiveStageJob().sysJobs" class="sys-container">
        <div v-for="output in sysJob.apiJob.output" class="sys-thumb"  v-bind:class="{ 'active': image === output.uri && activeStage.preview === true}" @click="chooseImage(output.uri)">

          <img :src="output.uri" class="sys-img">

        </div>
      </div>
      </div>
    </div>

    </div>


      <div class="bottom-bar-item-left">
        <div class="d-flex align-items-center gap-20">
          <span class="main-number" v-if="resultPage.isMediumRes === false"  v-bind:class="{ 'disabled': isActive === false, 'done': isDoneApply === true}">7</span>
          <span class="font-size-125">{{ "Continue with editing" | trans }}</span>
        </div>
        <div class="generate-btn-box" :class="{  }">
          <div
              class="generate-btn px-20"
              @click="applyImage"
              v-bind:class="{ 'disabled': isDone === false || this.loading}"
          >

            {{ 'Continue' | trans }}
            <i v-if="!loading" class="far fa-arrow-right font-size-150"></i>
            <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
          </div>
        </div>
      </div>




  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import currentJob from './../../mixins/current_job.mixin';
import CanvasManager from "../../manager/CanvasManager";
import StageManager from "../../manager/StageManager";
import CoinSVG from "../../../form/icons/CoinSVG.vue";
import {JOB_STATE_PROCESSING} from "../../const/job.const";
import {EventBus} from "../../events/event.bus";
import {EVENT_JOB_COMPLETE, EVENT_JOB_SELECT_OUTPUT, EVENT_JOB_SYS_SUCCESS} from "../../events/job.events";

export default {
  name: 'BottomInpaintChooser',
  props: {},
  components: {
    CoinSVG
  },
  mixins: [store, currentJob],
  data() {
    return {
      image: ''
    };
  },
  mounted: function () {
  },
  created: function () {
    EventBus.$on(EVENT_JOB_SYS_SUCCESS, (data) => {
      this.chooseImage(this.activeStage.sysJobs[0].apiJob.output[0].uri);
    });
    EventBus.$on(EVENT_JOB_SELECT_OUTPUT, (data) => {
      this.chooseActiveStage();
    });
  },
  methods: {
    chooseActiveStage() {
      //this.chooseImage(this.activeStage.mainJob.apiJob.output[0].uri);
      this.image = this.activeStage.mainJob.apiJob.output[0].uri;
      CanvasManager.setPreview(this.activeStage, this.activeStage.mainJob.apiJob.output[0].uri);
      CanvasManager.zoomFitAllObjects(this.activeStage);
      //CanvasManager.restoreCanvas(this.activeStage);
    },
    chooseImage(url) {
      this.activeStage.preview = true;
      this.image = url;
      CanvasManager.setPreview(this.activeStage, url);
      CanvasManager.zoomFitAllObjects(this.activeStage);
    },
    applyImage() {
      if (this.currentJob.state === JOB_STATE_PROCESSING) {
        return;
      }
      StageManager.loadNewStageImage(this.currentJob, this.image);
    }
  },
  computed: {
    isActive() {
      return this.activeStage.sysJobs.length > 0;
    },
    isDone() {
      return this.activeStage.preview === true && this.image !== '';
    },
    isDoneApply() {
      return false;
    }
  },
};
</script>
<style lang="scss" scoped>
.sys-container {
  height: 100%;
  display: flex;
  gap: 10px;

}

.sys-thumb {
  background: #1E1E1E;
  &.active {
    background: #1266F1 !important;
  }
  padding: 5px;
  border-radius: 4px;
  height: 100%;
  img {
    height: 100%;
  }
}

.bottom-bar-item {
  display:flex;
  align-items: center;
  gap: 10px;
  border-right: 1px solid #595959;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar-item-none {
  display:flex;
  align-items: center;
  gap: 10px;
  border: 0;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar-item-left {
  display:flex;
  align-items: center;
  gap: 10px;
  border-left: 1px solid #595959;
  height: 100%;
  padding: 0 20px;
}

.bottom-bar {
  justify-content: space-between;
  min-height: 105px;
  height: 105px;
  background: #272727;
  gap: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  border-top: 1px solid #595959;
}
</style>
